// Accessibility Fixes
document.addEventListener("DOMContentLoaded", function () {
  // =========================
  // Shared focus state
  // =========================
  let lastCartTrigger = null;
  let lastHalfDrawerTrigger = null;
  let lastHalfDrawerId = null;

  // =========================
  // Cart drawer focus
  // =========================
  const cartDrawer = document.getElementById("cart-drawer");

  document.addEventListener("click", function (e) {
    const cartTrigger = e.target.closest('[aria-controls="cart-drawer"]');
    if (cartTrigger) {
      lastCartTrigger = cartTrigger;
      return;
    }

    const addToCartBtn = e.target.closest('button[type="submit"][is="custom-button"]');
    if (addToCartBtn) {
      lastCartTrigger = addToCartBtn;
      return;
    }

    const halfDrawerTrigger = e.target.closest("button.new-btn[aria-controls]");
    if (halfDrawerTrigger) {
      lastHalfDrawerTrigger = halfDrawerTrigger;
      lastHalfDrawerId = halfDrawerTrigger.getAttribute("aria-controls");
    }
  });

  if (cartDrawer) {
    cartDrawer.addEventListener("dialog:after-show", function () {
      setTimeout(function () {
        cartDrawer.setAttribute("tabindex", "-1");
        cartDrawer.focus();
      }, 100);
    });

    cartDrawer.addEventListener("dialog:after-hide", function () {
      setTimeout(function () {
        if (lastCartTrigger && document.body.contains(lastCartTrigger)) {
          lastCartTrigger.focus();
        }
      }, 100);
    });
  }

  // =========================
  // Half-screen drawer focus
  // =========================
  document.querySelectorAll("x-drawer.drawer--half-screen").forEach(function (drawer) {
    drawer.addEventListener("dialog:after-show", function () {
      if (drawer.id === lastHalfDrawerId) {
        setTimeout(function () {
          drawer.setAttribute("tabindex", "-1");
          drawer.focus();
        }, 100);
      }
    });

    drawer.addEventListener("dialog:after-hide", function () {
      if (drawer.id === lastHalfDrawerId) {
        setTimeout(function () {
          if (lastHalfDrawerTrigger && document.body.contains(lastHalfDrawerTrigger)) {
            lastHalfDrawerTrigger.focus();
          }
        }, 100);
      }
    });
  });

  // =========================
  // Third party warning
  // =========================
  const warningText = "Redirecting to a third-party website (opens in a new tab).";

  function isThirdParty(url) {
    try {
      const linkHost = new URL(url, window.location.href).hostname;
      return linkHost && linkHost !== window.location.hostname;
    } catch (e) {
      return false;
    }
  }

  function handleExternalLinks() {
    document.querySelectorAll("a").forEach(function (link) {
      const href = link.getAttribute("href");
      if (!href || !isThirdParty(href)) return;

      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");

      const img = link.querySelector("img");

      if (img) {
        link.removeAttribute("aria-label");

        let alt = img.getAttribute("alt") || "";
        if (!alt.includes(warningText)) {
          img.setAttribute("alt", alt ? alt + ", " + warningText : warningText);
        }
        return;
      }

      if (link.classList.contains("et_pb_button")) {
        link.removeAttribute("aria-label");

        if (!link.querySelector(".visually-hidden")) {
          const span = document.createElement("span");
          span.className = "visually-hidden";
          span.textContent = warningText;
          link.appendChild(span);
        }
        return;
      }

      const text = link.textContent.trim();
      if (!text) return;

      const aria = link.getAttribute("aria-label");
      if (!aria || !aria.includes(warningText)) {
        link.setAttribute("aria-label", text + ", " + warningText);
      }
    });
  }

  setTimeout(handleExternalLinks, 500);

  // =========================
  // Email & phone labels
  // =========================
  document.querySelectorAll('a[href^="mailto:"], a[href^="tel:"]').forEach(function (el) {
    const href = el.getAttribute("href");
    if (!href) return;

    if (
      el.hasAttribute("aria-label") ||
      el.getAttribute("role") === "button" ||
      el.classList.contains("button") ||
      el.classList.contains("btn")
    ) {
      return;
    }

    if (href.startsWith("mailto:")) {
      const email = href.replace("mailto:", "").trim();
      el.setAttribute("aria-label", "Email Address: " + email);
    }

    if (href.startsWith("tel:")) {
      const text = el.textContent.trim();
      el.setAttribute("aria-label", "Phone number: " + text);
    }
  });

  // =========================
  // aria-hidden on <br>
  // =========================
  document.querySelectorAll("br").forEach(function (br) {
    br.setAttribute("aria-hidden", "true");
  });

  // =========================
  // Menu nav focus
  // =========================
 const navTriggers = document.querySelectorAll("button[aria-controls]");
const navDrawers = document.querySelectorAll(".navigation-drawer");

// store last opener per drawer
const lastFocusedTrigger = new Map();

navTriggers.forEach((trigger) => {
  const targetId = trigger.getAttribute("aria-controls");
  const targetDrawer = document.getElementById(targetId);

  if (!targetDrawer) return;

  // OPEN → store trigger
  trigger.addEventListener("click", () => {
    lastFocusedTrigger.set(targetId, trigger);
  });

  const closeBtn = targetDrawer.querySelector(
    ".sm-max\\:hidden, [is='close-button'], .sm-cl-bt"
  );

  if (!closeBtn) return;

  // observer for open state
  const observer = new MutationObserver(() => {
    if (targetDrawer.classList.contains("show-close-cursor")) {
      setTimeout(() => {
        closeBtn.setAttribute("tabindex", "-1");
        closeBtn.focus();
      }, 10);
    }
  });

  observer.observe(targetDrawer, {
    attributes: true,
    attributeFilter: ["class"]
  });

  // CLOSE → restore focus to correct trigger
  closeBtn.addEventListener("click", () => {
    setTimeout(() => {
      const trigger = lastFocusedTrigger.get(targetId);
      if (trigger) {
        trigger.focus();
      }
    }, 150);
  });
});

  // =========================
  // Main menu nav aria-expanded remove
  // =========================
  function removeHeaderNavAria() {
    const navButtons = document.querySelectorAll('.header__link-list button[aria-haspopup="dialog"]');
    navButtons.forEach(function (btn) {
      if (btn.hasAttribute("aria-expanded")) {
        btn.removeAttribute("aria-expanded");
      }
    });
  }

  const headerContainer = document.querySelector(".header__link-list");
  if (headerContainer) {
    const headerObserver = new MutationObserver(removeHeaderNavAria);

    headerObserver.observe(headerContainer, {
      attributes: true,
      subtree: true,
      attributeFilter: ["aria-expanded"]
    });

    removeHeaderNavAria();

    document.addEventListener(
      "click",
      function (e) {
        if (e.target.closest(".header__link-list button")) {
          setTimeout(removeHeaderNavAria, 10);
        }
      },
      true
    );
  }

  // =========================
  // 2nd menu popup remove aria-expanded
  // =========================
  const panel = document.querySelector(".panel__scroller");

  if (panel) {
    const selector = 'button.text-with-icon[data-panel]';

    function removePanelAria(root) {
      if (!root || !root.querySelectorAll) return;
      const elements = root.querySelectorAll(selector + "[aria-expanded]");
      elements.forEach(function (el) {
        el.removeAttribute("aria-expanded");
      });
    }

    removePanelAria(panel);

    const panelObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "aria-expanded" &&
          mutation.target.matches(selector)
        ) {
          mutation.target.removeAttribute("aria-expanded");
        }

        if (mutation.type === "childList") {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
              if (node.matches && node.matches(selector + "[aria-expanded]")) {
                node.removeAttribute("aria-expanded");
              }
              removePanelAria(node);
            }
          });
        }
      });
    });

    panelObserver.observe(panel, {
      attributes: true,
      subtree: true,
      childList: true,
      attributeFilter: ["aria-expanded"]
    });
  }
});

// End Accessibility Fixes


// Accessible Mobile Menu
document.addEventListener("DOMContentLoaded", function () {
  const menu = document.getElementById("header-sidebar-menu");

  if (menu) {
    menu.addEventListener("click", function (event) {
      const clickedButton = event.target.closest("button");
      if (!clickedButton) return;

      const clickedText = clickedButton.textContent.trim().toLowerCase();

      setTimeout(function () {
        const buttons = menu.querySelectorAll("button");
        let matches = [];
        let clickedIndex = -1;

        buttons.forEach((btn) => {
          const text = btn.textContent.trim().toLowerCase();

          if (text === clickedText) {
            matches.push(btn);
            if (btn === clickedButton) {
              clickedIndex = matches.length - 1;
            }
          }
        });

        if (matches.length > 1) {
          const nextIndex = (clickedIndex + 1) % matches.length;
          matches[nextIndex].focus();
        }
      }, 500);
    });
  }
});

// End Accessible Mobile Menu

// Accessible Desktop Menu
document.addEventListener("click", function (event) {
  const target = event.target.closest("button.text-with-icon.h6.text-subdued");
  if (!target) return;

  setTimeout(function () {
    document.querySelectorAll(".panel__wrapper").forEach(function (el) {
      el.removeAttribute("hidden");
    });
  }, 300);
});

document.addEventListener("DOMContentLoaded", function () {
  const menu = document.getElementById("navigation-drawer-1");

  if (menu) {
    menu.addEventListener("click", function (event) {
      const clickedButton = event.target.closest("button");
      if (!clickedButton) return;

      const clickedText = clickedButton.textContent.trim().toLowerCase();

      setTimeout(function () {
        const buttons = menu.querySelectorAll("button");
        let matches = [];
        let clickedIndex = -1;

        buttons.forEach((btn) => {
          const text = btn.textContent.trim().toLowerCase();

          if (text === clickedText) {
            matches.push(btn);
            if (btn === clickedButton) {
              clickedIndex = matches.length - 1;
            }
          }
        });

        if (matches.length > 1) {
          const nextIndex = (clickedIndex + 1) % matches.length;
          matches[nextIndex].focus();
        }
      }, 500);
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const isDesktop = window.matchMedia("(min-width: 1024px)");

  document.addEventListener("click", function (event) {
    if (!isDesktop.matches) return;

    const backBtn = event.target.closest(
      'button.text-with-icon.h6.text-subdued[data-panel="0"]'
    );
    if (!backBtn) return;

    const drawer = backBtn.closest("navigation-drawer");
    if (!drawer) return;

    const menuText = backBtn.textContent.trim().toLowerCase();

    setTimeout(function () {
      /* ===============================
         🔹 FIX DRAWER ROOT (IMPORTANT)
      =============================== */
      drawer.setAttribute("open", "");
      drawer.style.cssText = `
        left: 0px !important;
        top: 0px !important;
        opacity: 1 !important;
        visibility: visible !important;
        transform: none !important;
      `;

      /* ===============================
         🔹 FIX PANELS
      =============================== */
      const mainPanel = drawer.querySelector(".panel:first-child");
      const subPanel = drawer.querySelector(".panel:nth-child(2)");

      if (mainPanel) {
        mainPanel.setAttribute("open", "");
        mainPanel.style.opacity = "1";
        mainPanel.style.visibility = "visible";
      }

      if (subPanel) {
        subPanel.removeAttribute("open");
        subPanel.style.opacity = "0";
        subPanel.style.visibility = "hidden";
      }

      /* ===============================
         🔹 FIX WRAPPERS (REAL CONTROL)
      =============================== */
      const mainWrapper = drawer.querySelector(
        ".panel:first-child .panel__wrapper"
      );

      if (mainWrapper) {
        mainWrapper.removeAttribute("hidden");
      }

      const subWrappers = drawer.querySelectorAll(
        ".panel:nth-child(2) .panel__wrapper"
      );

      subWrappers.forEach((el) => el.setAttribute("hidden", ""));

      /* ===============================
         🔹 FIX ARIA + FOCUS
      =============================== */
      const mainButtons = drawer.querySelectorAll(
        ".panel:first-child button[data-panel]"
      );

      mainButtons.forEach((btn) => {
        btn.setAttribute("aria-expanded", "false");

        if (btn.textContent.trim().toLowerCase() === menuText) {
          btn.focus();
        }
      });

    }, 120); // slight delay to override Shopify script
  });
});

document.addEventListener("click", function (event) {
  const clickedBtn = event.target.closest("button");
  if (!clickedBtn) return;

  setTimeout(function () {
    document
      .querySelectorAll("button.text-with-icon.h6.text-subdued")
      .forEach(function (btn) {
        btn.removeAttribute("aria-expanded");
      });
  }, 150); // adjust delay if needed
});
// End Accessible Desktop Menu

// Basic Fixes
document.addEventListener("DOMContentLoaded", function () {
  const aside = document.querySelector("aside#shopify-section-announcement-bar");

  if (!aside) return;

  // Check if truly empty (no visible content)
  const isEmpty = aside.innerHTML.trim() === "" || aside.textContent.trim() === "";

  if (isEmpty) {
    aside.remove();
  }
});


// End Basic Fixes

///size chart h4 convert into h3
document
  .querySelectorAll(".prose.size-chart-content h4")
  .forEach((h4) => {
    const h3 = document.createElement("h3");

    // Copy attributes
    [...h4.attributes].forEach(attr => {
      h3.setAttribute(attr.name, attr.value);
    });

    // Copy content
    h3.innerHTML = h4.innerHTML;

    // Replace h4 with h3
    h4.replaceWith(h3);
  });

  ///Same Domain Removing target blank
  document.querySelectorAll('a[target="_blank"]').forEach((link) => {
  const linkUrl = new URL(link.href, window.location.origin);

  // Check if the link belongs to the same domain
  if (linkUrl.hostname === window.location.hostname) {
    // Remove target="_blank"
    link.removeAttribute('target');

    // Remove external warning text/attribute if exists
    link.removeAttribute('aria-label');
    link.removeAttribute('rel');

    // Example: remove custom external warning class
    link.classList.remove('external-link');

    // Example: remove external warning icon/text inside link
    const warning = link.querySelector('.external-warning');
    if (warning) {
      warning.remove();
    }
  }
});

///Collection here link label
document
  document
  .querySelectorAll('.prose.break-all.place-self-center.text-center')
  .forEach((section) => {
    section.querySelectorAll('a').forEach((anchor) => {
      const anchorText = anchor.textContent.trim();

      // Find closest paragraph containing the anchor
      const paragraph = anchor.closest('p');

      if (!paragraph) return;

      // Get paragraph text
      const paragraphText = paragraph.textContent.trim();

      // Set aria-label
      anchor.setAttribute(
        'aria-label',
        `${anchorText}, ${paragraphText}`
      );
    });
  });

  ///Accordian links title removed
  document
  .querySelectorAll('.accordion-box.rounded.bg-custom.text-custom')
  .forEach((section) => {
    // Find all anchors inside this section
    section.querySelectorAll('a').forEach((anchor) => {
      // Remove title attribute
      anchor.removeAttribute('title');
    });
  });

  ///Catalog change h2 into h1
  // document
  // .querySelectorAll('.prose.break-all.place-self-center.text-center')
  // .forEach((section) => {
  //   const h2 = section.querySelector('h2');

  //   if (h2) {
  //     // Create new h1
  //     const h1 = document.createElement('h1');

  //     // Copy content and attributes
  //     h1.innerHTML = h2.innerHTML;

  //     [...h2.attributes].forEach((attr) => {
  //       h1.setAttribute(attr.name, attr.value);
  //     });

  //     // Replace h2 with h1
  //     h2.replaceWith(h1);
  //   }
  // });

  ///Quick Button aria-expanded values removed
  document
  .querySelectorAll('.pointer-coarse\\:hidden button')
  .forEach((button) => {
    // Remove aria-expanded attribute
    button.removeAttribute('aria-expanded');
  });

  ///For Nvda fixes skip links
  document.addEventListener("DOMContentLoaded", () => {
  const skipLink = document.querySelector("a.skip-to-content.sr-only");
  const mainContent = document.querySelector("main, #main, [role='main']");

  if (!skipLink || !mainContent) return;

  skipLink.addEventListener("click", (e) => {
    e.preventDefault();

    // Make sure main content can receive focus
    if (!mainContent.hasAttribute("tabindex")) {
      mainContent.setAttribute("tabindex", "-1");
    }

    // Move focus to main content
    mainContent.focus();

    // Ensure it's visible in viewport
    mainContent.scrollIntoView({ behavior: "smooth", block: "start" });
  });
});

///home page h1 convert into h2
document.querySelectorAll('.place-self-center-start.text-start.sm\\:place-self-center-start.sm\\:text-start.text-custom h1')
  .forEach((h1) => {
    const h2 = document.createElement('h2');

    // copy all attributes
    [...h1.attributes].forEach(attr => {
      h2.setAttribute(attr.name, attr.value);
    });

    // copy content
    h2.innerHTML = h1.innerHTML;

    // replace h1 with h2
    h1.replaceWith(h2);
  });